import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import type { DuoPreferencesResponse } from 'generated/openapi';

import {
  getDuoPreferencesKey,
  getDuoPreferencesOptions,
} from './getDuoPreferences.options';

export interface UseGetDuoPreferencesProps<T = DuoPreferencesResponse> {
  options?: Omit<
    UseQueryOptions<DuoPreferencesResponse, unknown, T>,
    'queryKey' | 'queryFn'
  >;
}

export function useGetDuoPreferences<T = DuoPreferencesResponse>(
  props: UseGetDuoPreferencesProps<T>,
) {
  const { options } = props;

  return useQuery({
    ...getDuoPreferencesOptions<T>(),
    ...options,
  });
}

useGetDuoPreferences.getQueryKey = getDuoPreferencesKey;
